/*
  BNH — Ana sayfadaki Judge.me "müşteri yorumları" ızgarasını düzenler.

  Uygulama kartları seçim sırasına göre veriyor. Bu da iki soruna yol
  açıyor:
    1) Aynı siparişte birden fazla ürün değerlendirildiğinde aynı isim
       arka arkaya dört kez görünüyor.
    2) Yazılı yorumlar, yalnızca yıldızlı olanların arasında kayboluyor.

  Burada kartlar yeniden sıralanıyor (önce yazılı yorumlar), aynı
  kişinin tekrarları gizleniyor ve ekran genişliğine göre tam dolu
  satır sayısı kadar kart bırakılıyor.
*/
(function () {
  var SEL = '.jdgm-testimonials-carousel .jdgm-testimonials-container';

  function textOf(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  /* "Judge.me Shop Reviews" mağaza geneli yorumdur; ürün adı yerine
     uygulamanın kendi adını basıyor, kartta yamalı duruyor. */
  function isShopLevel(t) {
    return /judge\.?me/i.test(t);
  }

  /* "4.96 ★ (206)" yerine okunur bir künye. */
  function tidyHeader(root) {
    var rt = root.querySelector('.jdgm-rating-text');
    if (rt && !rt.dataset.nbDone) {
      var avg = (rt.textContent.match(/[\d.,]+/) || [''])[0];
      var count = textOf(rt.querySelector('.jdgm-reviews-count'));
      if (avg && count) {
        rt.textContent = avg + ' / 5 \u00b7 ' + count + ' de\u011ferlendirme';
        rt.dataset.nbDone = '1';
      }
    }
  }

  function colsFor() {
    var w = window.innerWidth;
    if (w <= 749) return 2;
    if (w <= 989) return 3;
    return 4;
  }

  function arrange(box) {
    var items = Array.prototype.slice.call(box.querySelectorAll('.jdgm-carousel-item'));
    if (!items.length) return false;

    var seen = {};
    var ranked = [];

    items.forEach(function (item, i) {
      var body = textOf(item.querySelector('.jdgm-text'));
      var product = textOf(item.querySelector('.jdgm-product-name'));
      var name = textOf(item.querySelector('.jdgm-reviewer-name'));
      /* Yorum yazılmamışsa uygulama gövdeye ürün adını basıyor. */
      var hasText = body.length > 0 && body !== product && body.length > 25;
      var shopLevel = isShopLevel(product) || (!hasText && isShopLevel(body));

      item.classList.toggle('nb-has-text', hasText);
      item.classList.toggle('nb-no-text', !hasText);

      ranked.push({
        el: item, i: i, hasText: hasText, shopLevel: shopLevel,
        name: name.toLowerCase()
      });
    });

    /* Yazılı yorumlar öne, kalanlar özgün sırasında. */
    ranked.sort(function (a, b) {
      if (a.hasText !== b.hasText) return a.hasText ? -1 : 1;
      return a.i - b.i;
    });

    var cols = colsFor();
    var limit = cols * 2;

    /* Önce uygun adayları seç: tekrar eden isim ve mağaza geneli yorum yok. */
    var picked = [];
    ranked.forEach(function (r) {
      if (r.shopLevel) return;
      if (r.name && seen[r.name]) return;
      if (r.name) seen[r.name] = true;
      if (picked.length < limit) picked.push(r);
    });

    /* Yarım satır bırakmaktansa satırı tamamen kaldır. */
    var keep = Math.floor(picked.length / cols) * cols;
    if (keep === 0) keep = Math.min(picked.length, cols);
    picked = picked.slice(0, keep);

    ranked.forEach(function (r) { r.el.classList.add('nb-hide'); });
    picked.forEach(function (r, idx) {
      r.el.style.order = String(idx);
      r.el.classList.remove('nb-hide');
    });

    box.classList.add('nb-ready');
    return true;
  }

  function run() {
    var root = document.querySelector('.jdgm-testimonials-carousel');
    if (root) tidyHeader(root);
    var box = document.querySelector(SEL);
    return box ? arrange(box) : false;
  }

  var tries = 0;
  var t = setInterval(function () {
    if (run() || ++tries > 40) clearInterval(t);
  }, 300);

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(run, 200);
  }, { passive: true });
})();
